import { graphql } from '@/gql';
import type { OperationMetricsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { OperationMetric } from '@/models/statistic';

export const fetchOperationMetrics = async ({ startDate, endDate, type }: OperationMetricsQueryVariables): Promise<OperationMetric[]> => {
  const response = await queryExecute({
    query: graphql(`
      query OperationMetrics($startDate: String!, $endDate: String!, $type: String) {
        operationMetrics(startDate: $startDate, endDate: $endDate, type: $type) {
          id
          date
          hour
          handleTime
          waitTime
          operatorId
        }
      }
    `),
    variables: {
      startDate,
      endDate,
      type,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.operationMetrics ?? [];
};
